/*
 * PDP Buy Now + mobile sticky buy bar.
 * Buy Now checks the minimum order (cart total + this item), then:
 *   - mode "gokwik": loads the delayed GoKwik script and calls its onBuyNowClick (same flow as the cart drawer);
 *   - otherwise (or if GoKwik isn't available): adds the item via /cart/add.js and goes to /checkout.
 */
(function () {
  if (window.__pdpBuyNowInit) return;
  window.__pdpBuyNowInit = true;

  function readConfig(formId) {
    const el = document.querySelector('script[data-pdp-buy-config="' + formId + '"]');
    try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; }
  }

  function waitFor(test, timeout) {
    return new Promise((resolve) => {
      const start = Date.now();
      (function tick() {
        if (test()) return resolve(true);
        if (Date.now() - start > timeout) return resolve(false);
        setTimeout(tick, 100);
      })();
    });
  }

  function setup(btn) {
    const formId = btn.dataset.form;
    const form = document.getElementById(formId);
    const cfg = readConfig(formId);
    if (!form || !cfg) return;
    const productForm = form.closest('product-form');
    const msg = productForm && productForm.querySelector('.pdp-buy-now__msg');
    const atc = form.querySelector('[name="add"]');
    const sticky = document.querySelector('[data-pdp-sticky="' + formId + '"]');
    const stickyBuy = sticky && sticky.querySelector('[data-pdp-sticky-buy]');
    const stickyAtc = sticky && sticky.querySelector('[data-pdp-sticky-atc]');
    let busy = false;

    const variantId = () => Number((form.querySelector('input[name="id"]') || {}).value);
    const quantity = () => {
      const q = form.querySelector('input[name="quantity"]') || document.querySelector('input[name="quantity"][form="' + formId + '"]');
      return Math.max(1, parseInt(q && q.value, 10) || 1);
    };

    function showMsg(text) {
      if (!msg) return;
      msg.textContent = text;
      msg.hidden = !text;
    }

    function setLoading(on) {
      [btn, stickyBuy].forEach((b) => {
        if (!b) return;
        b.classList.toggle('is-loading', on);
        b.setAttribute('aria-busy', on ? 'true' : 'false');
      });
    }

    // Keep Buy Now (and sticky buttons) in sync with the theme's Add to Cart state.
    function syncDisabled() {
      const off = !atc || atc.disabled;
      [btn, stickyBuy, stickyAtc].forEach((b) => { if (b) b.disabled = off; });
    }
    if (atc) new MutationObserver(syncDisabled).observe(atc, { attributes: true, attributeFilter: ['disabled'] });
    syncDisabled();

    async function buyNow() {
      if (busy || btn.disabled) return;
      busy = true;
      showMsg('');
      setLoading(true);
      const id = variantId();
      const qty = quantity();
      try {
        if (!(cfg.minOrder > 0) && window.amMinOrder > 0) cfg.minOrder = window.amMinOrder;
        if (cfg.minOrder > 0) {
          const cart = await fetch(cfg.cartUrl, { headers: { Accept: 'application/json' } }).then((r) => r.json());
          const unit = cfg.variants[String(id)] || 0;
          if ((cart.total_price + unit * qty) / 100 < cfg.minOrder) {
            showMsg(String(cfg.minMessage || '').replace('[min]', '₹' + cfg.minOrder));
            return;
          }
        }
        if (btn.dataset.mode === 'gokwik') {
          if (window.amLoadDelayed) { try { await window.amLoadDelayed(); } catch (e) { /* fall through */ } }
          const ready = await waitFor(() => typeof window.onBuyNowClick === 'function' && window.gokwikSdk, 6000);
          if (ready) {
            setLoading(false);
            window.onBuyNowClick(btn, false, [{ id: id, quantity: qty }]);
            return;
          }
        }
        const res = await fetch(cfg.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || err.message || cfg.errorMessage);
        }
        window.location.href = cfg.checkoutUrl;
        return;
      } catch (e) {
        showMsg((e && e.message) || cfg.errorMessage);
      } finally {
        busy = false;
        setLoading(false);
      }
    }

    btn.addEventListener('click', (e) => { e.preventDefault(); buyNow(); });

    if (!sticky) return;
    stickyBuy && stickyBuy.addEventListener('click', buyNow);
    stickyAtc && stickyAtc.addEventListener('click', () => { if (atc && !atc.disabled) atc.click(); });

    // Mirror the visible price into the sticky bar when the variant changes.
    const sectionId = formId.replace(/^product-form-/, '');
    const priceBox = document.getElementById('price-' + sectionId);
    const stickyPrice = sticky.querySelector('[data-pdp-sticky-price]');
    function syncPrice() {
      if (!priceBox || !stickyPrice) return;
      const items = [...priceBox.querySelectorAll('.price-item')].filter((el) => el.offsetParent !== null && !el.closest('s'));
      const last = items[items.length - 1];
      if (last) stickyPrice.textContent = last.textContent.trim();
    }
    if (priceBox) new MutationObserver(syncPrice).observe(priceBox, { childList: true, subtree: true, characterData: true });
    syncPrice();

    // Sit just above the floating bottom navigation (measured, since its height comes from other settings).
    function placeSticky() {
      const nav = document.querySelector('.mobile__navigation--bar');
      const navTop = nav && getComputedStyle(nav).display !== 'none' ? nav.getBoundingClientRect().top : window.innerHeight;
      const root = document.documentElement.style;
      root.setProperty('--pdp-sticky-bottom', Math.max(10, Math.round(window.innerHeight - navTop + 10)) + 'px');
      root.setProperty('--pdp-sticky-h', sticky.offsetHeight + 'px');
    }
    window.addEventListener('resize', () => { if (!sticky.hidden) placeSticky(); });

    // Show the sticky bar on mobile once the main buttons scroll above the viewport.
    const actions = form.querySelector('.pdp-actions') || btn;
    const mq = window.matchMedia('(max-width: 749px)');
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        const show = mq.matches && !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.hidden = !show;
        if (show) placeSticky();
        document.documentElement.classList.toggle('pdp-sticky-open', show);
      }).observe(actions);
    }
  }

  function init() { document.querySelectorAll('[data-pdp-buy-now]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
